module.exports = __webpack_public_path__ + "static/img/banTc.187af98.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banTc.jpg
// module id = akIv
// module chunks = 1